















import {
  Vue, Component, Prop, Watch, Mixins,
} from 'vue-property-decorator'
import { getModule, VuexModule } from 'vuex-module-decorators'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import AppStore from '../../store/modules/app'

@Component({
  components: {
  },
})
export default class PageTemplate extends Mixins(MainMixin) {
  @Prop() title!:string

  @Prop({ default: null }) tabs:any

  @Prop({ default: null }) showToolbar!:Function|null

  AppStore = getModule(AppStore)

  activeTab = this.tabs ? this.tabs[0].value : null

  showDetails = false

  setActiveTab(x:any) {
    // ts-ignore-next-line
    console.log('tabv set to: ', x, this.$store.state)
    this.AppStore.setTab(x)
  }

  created() {
    this.EventBus.$on('switch-tab', (tab:string) => {
      this.activeTab = tab
    })
    if (this.tabs && this.tabs.length > 0) {
      this.AppStore.setTab(this.tabs[0].value)
    }
  }
}

